import { message } from 'antd'
import axios from 'axios'
import { AuthService } from '..'
import app from '../../dvaInstance'
import { OpenAPI } from './OpenAPI'

// Instantiate the interceptor
axios.interceptors.response.use(
  function (response) {
    return response
  },

  function (error) {
    const originalRequest = error.config
    const refreshToken = localStorage.getItem('refresh_token')

    if (error.response.data.code === 'user_inactive') {
      message.error('Your account is deactivated')
      // @ts-expect-error : Will update later
      app._store.dispatch({
        type: 'auth/userSignOut',
        onSuccess: () => {
          window.location.href = '/login'
        },
      })
      return Promise.reject(error)
    }

    if (error.response.status === 401 && !originalRequest._retry && refreshToken) {
      originalRequest._retry = true
      return AuthService.authRefreshCreate({
        requestBody: {
          refresh: refreshToken,
        },
      }).then((response) => {
        localStorage.setItem('access_token', response.access)
        localStorage.setItem('refresh_token', response.refresh)
        OpenAPI.TOKEN = response.access
        originalRequest.headers['Authorization'] = 'Bearer ' + response.access
        return axios(originalRequest)
      })
    }
    return Promise.reject(error)
  }
)

export default axios
